import { Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less'],
  host: {
    '[class]': 'variant',
  },
})
export class TabsComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'transparent', 'no-edge-padding', 'dark', 'no-shadow', 'simple'],
  ];
  @ComponentVariant(TabsComponent.VARIANTS)
  @Input()
  public variant: string;
}
